<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20 pt-15 items-center">
        <div class="bold9 size20 color1">
          成交公告详情页
          <!-- <span style="font-size: 14px; color: #ccd9e9"> Bulletin Details</span> -->
        </div>
        <span style="font-size: 14px; color: #ccd9e9"
          >浏览量：{{ SysAnnDetail.views }}</span
        >
      </div>
      <!-- 内容 -->
      <div class="chengjiao-box content">
        <el-descriptions
          :column="2"
          border
          labelClassName="my-label"
          contentClassName="my-content"
        >
          <el-descriptions-item
            label="竞价标题"
            label-class-name="my-label"
            content-class-name="my-content"
            >{{ SysAnnDetail.title }}</el-descriptions-item
          >
          <el-descriptions-item label="发布单位">{{
            SysAnnDetail.publishCompany
          }}</el-descriptions-item>
          <el-descriptions-item label="场次号">{{
            SysAnnDetail.sessionNum
          }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{
            SysAnnDetail.linker
          }}</el-descriptions-item>
          <el-descriptions-item label="竞价开始时间">{{
            SysAnnDetail.beginTime
          }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{
            SysAnnDetail.linkMode
          }}</el-descriptions-item>
          <el-descriptions-item label="竞价结束时间">{{
            SysAnnDetail.endTime
          }}</el-descriptions-item>
          <el-descriptions-item label="付款方式">{{
            SysAnnDetail.payMode == 1 ? "一次性付清" : "阶段性付款"
          }}</el-descriptions-item>
          <el-descriptions-item label="参与方式">{{
            SysAnnDetail.participationMode == 1 ? "公开" : "非公开"
          }}</el-descriptions-item>
          <el-descriptions-item label="出价方式">{{
            SysAnnDetail.biddingMode == 1 ? "连续报价" : "连续报价"
          }}</el-descriptions-item>
          <el-descriptions-item label="备注">
            {{ SysAnnDetail.remark }}
            <!-- <div
              class="pointer btn"
              @click="downFile(SysAnnDetail.attachmentsList)"
            >
              下载
            </div> -->
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          v-for="item in SysAnnDetail.subDetailList"
          :key="item.id"
          labelClassName="my-label"
          contentClassName="my-content"
          :column="3"
          border
        >
          <el-descriptions-item label="分包标题" label-class-name="my-label">
            <div style="width: 220px">{{ item.subTitle }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="拟成交供应商">
            <div style="width: 300px">{{ item.dealSupplierName }}</div>
          </el-descriptions-item>
          <!-- <el-descriptions-item label="附件" label-class-name="my-label1">
            <div class="flex items-center flex-center" style="width: 100px">
              <span class="pointer text" @click="downLoad(item.productDetail)"
                >下载</span
              >
              <span class="ml-5 mr-5">|</span>
              <span class="pointer text">预览</span> 
            </div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item label="备注">资质齐全</el-descriptions-item> -->
        </el-descriptions>
      </div>
    </div>

    <Footer class="mt-15" />
    <Result
      :title="resultTitle"
      :SubTitle="subTitle1"
      :isShow="resultShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Result from "../components/Result.vue";

export default {
  components: { Footer, Result },

  data() {
    return {
      resultTitle: "",
      subTitle1: "",
      resultShow: false,
      SysAnnDetail: {},
      did: null,
    };
  },
  created() {
    this.did = this.$route.query.id;
  },
  mounted() {
    this.getSystemDetail();
    this.viewsAdd();
  },
  methods: {
    resultClose() {
      this.resultShow = false;
    },
    //点击公告附件下载
    downFile(str) {
      console.log(str);
    },
    //点击fenbao 下载
    downLoad(item) {
      if (!item) {
        this.resultTitle = "暂无附件";
        this.subTitle1 = "";
        this.resultShow = true;
        return;
      }
      // let url = item.replace("/profile/upload", "");
	  let url = item.slice(item.indexOf("/profile/upload") + 15);
      // window.open("http://81.70.253.119:8081/common/download?fileName=" + url);
	  window.open(this.$static.SERVER_URL + "/common/download?fileName=" + url);
    },
    //获取成交公告详情
    async getSystemDetail() {
      const { data: res } = await this.$axios.get(
        "/api/annInfo/getDealAnnDetail",
        {
          params: {
            dealAnnId: this.did,
          },
        }
      );
      if (res.code == 200) {
        this.SysAnnDetail = res.data;
      } else {
        console.log(res.msg);
        return;
      }
    },
    //提交浏览量
    async viewsAdd() {
      const { data: res } = await this.$axios({
        url: "/api/annInfo/updateView",
        method: "put",
        params: {
          annId: this.did,
          annType: 3,
        },
      });
      console.log(res);
    },
  },
};
</script>
<style lang="less">
.my-label {
  width: 200px;
  text-align: center !important;
  font-weight: bold !important;
}
.my-label1 {
  width: 100px;
  text-align: center !important;
  font-weight: bold !important;
  border: 1px solid #ccd9e9 !important;
  color: #3b426b !important;
}
.my-content {
  text-align: center !important;
}
</style>
<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}
/deep/.divider.el-divider--horizontal {
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #95b3db;
}
.listBox {
  width: 855px;
  height: 855px;
  background-color: #fff;
  padding: 32px 40px;
  box-sizing: border-box;
}
.chengjiao-box {
  padding: 15px 20px;
  .text {
    color: #1c65c4;
    font-weight: bold;
  }
}
</style>